import { Link, useLocation } from "react-router-dom";
import '../../CSS/layout/Header.css';
import logo from '../../resource/water_logo(white).png';
import VisitCounter from "./VisitCounter";
import { useState, useEffect } from "react";

const NAV = [
    { to: '/about',       label: '펜션안내' },
    { to: '/rooms',       label: '객실안내' },
    { to: '/reservation', label: '예약안내' },
    { to: '/services',    label: '서비스이용' },
    { to: '/gallery',     label: '갤러리' },
];

const Header = () => {
    const location = useLocation();
    const [menuOpen, setMenuOpen]   = useState(false);
    const [scrolled, setScrolled]   = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 8);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    useEffect(() => { setMenuOpen(false); }, [location.pathname]);

    return (
        <header className={`header${scrolled ? ' header--scrolled' : ''}`}>
            <div className="header-inner">
                <Link to="/" className="logo">
                    <img src={logo} alt="물조은펜션" />
                </Link>

                <nav className="nav-menu">
                    {NAV.map(({ to, label }) => (
                        <Link
                            key={to}
                            to={to}
                            className={`nav-link${location.pathname === to ? ' nav-link--active' : ''}`}
                        >
                            {label}
                        </Link>
                    ))}
                </nav>

                <VisitCounter />

                <button className="hamburger" onClick={() => setMenuOpen(true)} aria-label="메뉴 열기">
                    <span /><span /><span />
                </button>

                {menuOpen && (
                    <>
                        <div className="backdrop" onClick={() => setMenuOpen(false)} />
                        <nav className="mobile-menu">
                            <button className="mobile-menu-close" onClick={() => setMenuOpen(false)} aria-label="메뉴 닫기">✕</button>
                            <Link to="/">홈</Link>
                            {NAV.map(({ to, label }) => (
                                <Link
                                    key={to}
                                    to={to}
                                    className={location.pathname === to ? 'active' : ''}
                                >
                                    {label}
                                </Link>
                            ))}
                        </nav>
                    </>
                )}
            </div>
        </header>
    );
};

export default Header;